import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { LocalizeRouterService } from 'localize-router';
import { PreferitiService } from '../../_services/preferiti.service';
import { HeaderService } from '../../_services/header.service';
import { AuthService } from '../../_services/auth.sevice';
var CardComponent = /** @class */ (function () {
    function CardComponent(preferiti, localize, auth, header) {
        this.preferiti = preferiti;
        this.localize = localize;
        this.auth = auth;
        this.header = header;
        this.showAcquista = true;
        this.aggiungiAlCarrelloClicked = new EventEmitter();
        this.pathFile = ''; // mettere il percorso dell'immagine placholder in caso di assenza di foto
        this.bolliniEvidenziati = [];
        this.bwCard = false;
        this.isPreferito = false;
        this.subs = [];
        this.isLoggedIn = this.auth.isLogged;
    }
    Object.defineProperty(CardComponent.prototype, "acquistaDisabled", {
        get: function () {
            return (this.scheda &&
                this.scheda.infoCommerciali &&
                this.scheda.infoCommerciali.FLAG_NON_DISPONIBILE &&
                this.scheda.infoCommerciali.FLAG_NON_DISPONIBILE.valore === 'true');
        },
        enumerable: true,
        configurable: true
    });
    CardComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.scheda) {
            this.bwCard = this.scheda.bollini ? this.scheda.bollini.find(function (bollino) { return bollino.nome === 'BWCard'; }) : null;
            var slugScheda = this.scheda.seo.slug ? this.scheda.seo.slug : this.scheda.seo[this.localize.parser.currentLang.toUpperCase()].slug;
            this.urlDettaglio = this.scheda.categorie[0] && this.scheda.sottocategorie[0] ? '/' + this.scheda.categorie[0].seo.slug + '/' + this.scheda.sottocategorie[0].seo.slug + '/' + slugScheda : undefined;
            if (this.scheda.staffaTelaio || this.scheda.staffaPortiera) {
                this.urlDettaglio += "?staffaTelaio=" + (this.scheda.staffaTelaio ? this.scheda.staffaTelaio.id : null) + "&staffaPortiera=" + (this.scheda.staffaPortiera ? this.scheda.staffaPortiera.id : null) + "&idPercorso=" + this.scheda.idPercorso;
            }
            this.fotoPrincipale = this.scheda.foto instanceof Array ?
                this.scheda.foto.find(function (foto) { return foto.principale; }) || this.scheda.foto[0] :
                this.scheda.foto;
            if (this.isLoggedIn) {
                this.preferiti.getPreferiti().subscribe(function (preferiti) { return _this.isPreferito = preferiti.find(function (p) { return p.idScheda === (_this.scheda.id || _this.scheda.idScheda); }); });
                this.subs.push(this.header.aggiornaPreferiti.subscribe(function () {
                    _this.preferiti.getPreferiti().subscribe(function (preferiti) { return _this.isPreferito = preferiti.find(function (p) { return p.idScheda === (_this.scheda.id || _this.scheda.idScheda); }); });
                }));
            }
        }
    };
    CardComponent.prototype.ngOnDestroy = function () {
        this.subs.forEach(function (s) { return s.unsubscribe(); });
    };
    CardComponent.prototype.aggiungiAlCarrello = function () {
        this.aggiungiAlCarrelloClicked.emit();
    };
    CardComponent.prototype.aggiungiAiPreferiti = function () {
        this.isPreferito ?
            this.preferiti.deletePreferito(this.scheda).subscribe() :
            this.preferiti.salvaPreferito(this.scheda).subscribe();
    };
    return CardComponent;
}());
export { CardComponent };
